import { API_ROOT } from '../config/ApiConfig';
import { generateRequestHeaders, extractErrorMessage } from '../service/ApiService';
import { BannerAdminUser } from '../models/banner/BannerAdminUser';

const BANNER_ADMINS_ROOT = `${API_ROOT}/maintenance-banner/admins`;

/**
 * Resolves to true only when the call succeeds and the server reports the
 * caller as a maintenance banner admin. Any failure (network, auth, non-ok
 * response) resolves to false rather than rejecting.
 */
export async function checkBannerAdminAccess(): Promise<boolean> {
  try {
    const response = await fetch(`${BANNER_ADMINS_ROOT}/me`, {
      headers: generateRequestHeaders()
    });
    if (!response.ok) {
      return false;
    }
    const body = await response.json();
    return Boolean(body.allowed);
  } catch {
    return false;
  }
}

export async function getBannerAdmins(): Promise<BannerAdminUser[]> {
  const response = await fetch(BANNER_ADMINS_ROOT, {
    headers: generateRequestHeaders()
  });
  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Failed to load Manage Banner admins'));
  }
  return response.json();
}

export async function addBannerAdmin(email: string): Promise<BannerAdminUser> {
  const response = await fetch(BANNER_ADMINS_ROOT, {
    method: 'POST',
    headers: generateRequestHeaders(),
    body: JSON.stringify({ email })
  });
  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Failed to add Manage Banner admin'));
  }
  return response.json();
}

export async function removeBannerAdmin(email: string): Promise<void> {
  const response = await fetch(`${BANNER_ADMINS_ROOT}/${encodeURIComponent(email)}`, {
    method: 'DELETE',
    headers: generateRequestHeaders()
  });
  if (!response.ok) {
    throw new Error(await extractErrorMessage(response, 'Failed to remove Manage Banner admin'));
  }
}
